import {
  EspdResponseDataType,
  type EspdResponseDto,
  type ResolvedEspdCriterionDto,
  type SelectionCriterionDto,
} from "../../../../../autogen/bff-api";
import { espdAnswerFor } from "../espd/useEspdAnswers";
import { ContributingEntitiesPanel } from "./ContributingEntitiesPanel";
import { contributingRoleForTypeCode } from "./contributingEntityRoles";
import { groupNameRequirementIdOf, groupRoleRequirementIdOf } from "./supplierDeclarationFields";

interface Props {
  criterion: ResolvedEspdCriterionDto;
  espd: EspdResponseDto;
  onEspdChange: (next: EspdResponseDto) => void;
  bidId: string;
  selectionCriteria: SelectionCriterionDto[];
  readOnly: boolean;
}

export const ContributingEntitiesSection = ({
  criterion,
  espd,
  onEspdChange,
  bidId,
  selectionCriteria,
  readOnly,
}: Props) => {
  const role = contributingRoleForTypeCode(criterion.typeCode);
  if (!role) return null;

  const leadIndicator = criterion.requirementGroups[0]?.requirements.find(
    (r) => r.responseDataType === EspdResponseDataType.Indicator,
  );
  if (!leadIndicator) return null;
  if (espdAnswerFor(espd, leadIndicator.id)?.indicator !== true) return null;

  return (
    <ContributingEntitiesPanel
      bidId={bidId}
      role={role}
      selectionCriteria={selectionCriteria}
      readOnly={readOnly}
      espd={espd}
      onEspdChange={onEspdChange}
      groupRoleRequirementId={groupRoleRequirementIdOf(criterion)}
      groupNameRequirementId={groupNameRequirementIdOf(criterion)}
    />
  );
};
